// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__mIGbf","buttons":"Footer_buttons__tXmW6"};